import axios from "axios"

class LogsAPI {
  sendLogMessage = async params => {
    return axios.post(`api/logs`, params)
  }
}

export const logs = new LogsAPI()
